export default "__VITE_ASSET__Ba1OkEvS__"